import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";

const SUPER_ADMIN_EMAIL = "hello@buukd.co";

export function useSuperAdmin() {
  const { user } = useAuth();
  
  const isSuperAdmin = useMemo(() => {
    return user?.email?.toLowerCase() === SUPER_ADMIN_EMAIL.toLowerCase();
  }, [user?.email]);

  return {
    isSuperAdmin,
    email: user?.email,
  };
}
